import React, { useRef, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../../config/firebase';
import useBusinessCategories from '../../useBusinessCategories';
import '../BusinessProfileCreation.css';

export default function AdminCategories() {
  const { categories, loading, error, refresh } = useBusinessCategories();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [saveError, setSaveError] = useState('');
  const busy = useRef(false);
  const save = async e => {
    e.preventDefault();
    if (busy.current) return;
    busy.current = true;
    setSaving(true);
    setSaveError('');
    setMessage('');
    try {
      const result = await httpsCallable(getFunctions(app), 'adminCreateCategory')({ name });
      setName('');
      setMessage(`${result.data.name} added.`);
      await refresh();
    } catch (err) { setSaveError(err.message || 'Could not add category.'); }
    finally { busy.current = false; setSaving(false); }
  };
  return <section className="admin-panel step-panel">
    <h2>Business categories</h2>
    <p>Add a category to make it available in the console’s business forms.</p>
    <form onSubmit={save}>
      <label htmlFor="category-name">New category name</label>
      <input id="category-name" required maxLength={80} value={name} disabled={saving} onChange={e => setName(e.target.value)} />
      <div className="step-actions"><button className="btn-primary" disabled={saving || loading || Boolean(error)}>{saving ? 'Adding…' : 'Add Category'}</button></div>
    </form>
    {saveError && <p role="alert" className="form-error">{saveError}</p>}
    {message && <p role="status">{message}</p>}
    {error && <p role="alert">{error} <button type="button" onClick={refresh}>Retry</button></p>}
    {loading ? <p role="status">Loading categories…</p> : <ul aria-label="Business categories">{categories.map(c => <li key={c}>{c}</li>)}</ul>}
  </section>;
}
